export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const OFFER_DATE_FORMAT = "ddd D MMM YYYY";
export const PICKADATE_UK_DATE_FORMAT = "dd/mm/yyyy";
export const SUMMARY_DATE_FORMAT = "dddd Do MMMM YYYY";
export const SUMMARY_DATE_FORMAT_SHORT = "ddd D MMM YY";
export const UK_DATE_FORMAT = "DD/MM/YYYY";



// WEBPACK FOOTER //
// ./const/DateFormatConsts.js